export const getBeautifiedLocalDate = (utcDate: string | Date): string => {
  const utc = new Date(utcDate);

  const timezoneOffsetMinutes = utc.getTimezoneOffset();

  const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

  const localDate = new Date(utc.getTime() - timezoneOffsetMilliseconds);

  return localDate.toLocaleDateString('fr-CA');
};

export const getBeautifiedLocalTime = (utcDate: string): string => {
  const utc = new Date(utcDate);

  const timezoneOffsetMinutes = utc.getTimezoneOffset();

  const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

  const localDate = new Date(utc.getTime() - timezoneOffsetMilliseconds);

  return localDate.toLocaleTimeString();
};

export const getBeautifiedLocalDateTime = (utcDate: string): string => {
  const utc = new Date(utcDate);

  const timezoneOffsetMinutes = utc.getTimezoneOffset();

  const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

  const localDate = new Date(utc.getTime() - timezoneOffsetMilliseconds);

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(localDate.getDate()).padStart(2, '0');
  const hours = String(localDate.getHours()).padStart(2, '0');
  const minutes = String(localDate.getMinutes()).padStart(2, '0');

  // Construct the formatted string
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

  return formattedDateTime;
};

export const getLocalDateTimeFromUtc = (utcDate: string): string => {
  const utc = new Date(utcDate);

  const timezoneOffsetMinutes = utc.getTimezoneOffset();

  const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

  const newDate = new Date(utc.getTime() - timezoneOffsetMilliseconds * 2);

  return newDate.toISOString().split('.')[0];
};
